// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"436609ab","879":"6cbb93d4"}[chunkId] + ".chunk.js";
};